export default class OrderSigner {

  static TYPE_CUSTOMER = 1;
  static TYPE_DEALER = 2;

  static ENTERPRISE_TYPE_CORPORATION = 1;
  static ENTERPRISE_TYPE_LLC = 2;
  static ENTERPRISE_TYPE_PARTNERSHIP = 3;
  static ENTERPRISE_TYPE_PROPRIETOR = 4;
  static ENTERPRISE_TYPE_COOPERATIVE = 5;
  static ENTERPRISE_TYPE_NON_PROFIT = 6;
  static ENTERPRISE_TYPE_PUBLIC_SECTOR_GOVERNMENT = 7;

  static getEnterpriseTypeMap() {
    return {
      [this.ENTERPRISE_TYPE_CORPORATION]: 'Corporation',
      [this.ENTERPRISE_TYPE_LLC]: 'LLC',
      [this.ENTERPRISE_TYPE_PARTNERSHIP]: 'Partnership',
      [this.ENTERPRISE_TYPE_PROPRIETOR]: 'Proprietor',
      [this.ENTERPRISE_TYPE_COOPERATIVE]: 'Cooperative',
      [this.ENTERPRISE_TYPE_NON_PROFIT]: 'Non-Profit',
      [this.ENTERPRISE_TYPE_PUBLIC_SECTOR_GOVERNMENT]: 'Public Sector/Government'
    };
  }

  static getEnterpriseTypeName(id) {
    return this.getEnterpriseTypeMap()[id];
  }

}